import { useContext } from "react";
import { CommonDataContext } from "../context/CommonDataContext";
import { BookingJourney, BookingJourneySegment, MyBookings } from "../global";
import { extractResource } from "./extractResource";

const getNoOfStops = (noOfStops: number, flightType: string = "") => {
  const { resources } = useContext(CommonDataContext);

  if (flightType === "Through") {
    return flightType;
  } else {
    switch (noOfStops) {
      case 0:
        return resources?.stops?.zero;
      case 1:
        return resources?.stops?.one;
      case 2:
        return resources?.stops?.two;
      case 3:
        return resources?.stops?.two?.replace("{}", noOfStops);
      default:
        return noOfStops;
    }
  }
};

export default getNoOfStops;

export const getListOfStops = (journey: BookingJourney) => {
  const listOfStops: string[] = [];
  const segments = journey?.segments;
  segments?.map((segment: BookingJourneySegment) =>
    segment?.legs?.map((leg) => listOfStops.push(leg?.designator?.destination))
  );

  // removing the last stop since it is the final desination of the journey - it should not be shown as a stop
  listOfStops?.pop();

  return listOfStops;
};

export const showStops = (journey: BookingJourney | MyBookings, returnAsStopOverAt?: boolean) => {
  const { resources } = useContext(CommonDataContext);

  const listOfStops = journey.stops && Array.isArray(journey.stops) ? journey.stops : getListOfStops(journey);
  const noOfStops = listOfStops.length;

  let stopsNames = "";
  listOfStops?.forEach((stops, idx) => {
    stopsNames += stops;
    if (idx < listOfStops.length - 1) {
      stopsNames += ", ";
    }
  });

  if (noOfStops === 0) {
    return getNoOfStops(0);
  }
  if (returnAsStopOverAt) {
    return `${extractResource(resources, "stopOverAt")} ${stopsNames}`;
  }
  return `${getNoOfStops(noOfStops)} • ${stopsNames}`;
};

export const getFlightNumbers = (journey: BookingJourney) => {
  const flightNumbersArray: string[] = [];

  journey?.segments?.forEach((segment: BookingJourneySegment) => {
    flightNumbersArray.push(segment?.identifier?.carrierCode + segment?.identifier?.identifier);
  });

  return flightNumbersArray.join(", ");
};
